import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import bgImg from '../Images/book-appointment.webp'
import Breadcrumb from "../Components/Breadcrumb";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt
} from "react-icons/fa";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useRecaptcha } from "../Components/Recaptcha";
import BookAppointmentSchema from "../Schema/BookAppointmentSchema";
import MedicalClinicSchema from "../Schema/MedicalClinicSchema";
import BreadcrumbSchema from "../Schema/BreadcrumbSchema";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import sendMetaEvent from "../Utils/metaTracking";

const BookAppointment=()=>{
    useEffect(() => {
                document.title =
                  "Book an Appointment | Dr. Jigar Gor Ayurvedic Clinic";
            
                const metaDesc = document.querySelector("meta[name='description']");
                if (metaDesc) {
                  metaDesc.setAttribute(
                    "content",
                    "Book an appointment with Dr. Jigar Gor for professional Ayurvedic treatment & custom Panchkarma therapies in Bhuj, Kutch."
                  );
                }
            
               const canonical = document.querySelector("link[rel='canonical']");
              if (canonical) {
                canonical.setAttribute("href", "https://msayurved.com/book-appointment");
              }
            
              const ogTitle = document.querySelector("meta[property='og:title']");
              if (ogTitle) {
                ogTitle.setAttribute(
                  "content",
                  "Book an Appointment | Dr. Jigar Gor Ayurvedic Clinic"
                );
              }
            
                const ogDesc = document.querySelector("meta[property='og:description']");
              if (ogDesc) {
                ogDesc.setAttribute(
                  "content",
                  "Book an appointment with Dr. Jigar Gor for professional Ayurvedic treatment & custom Panchkarma therapies in Bhuj, Kutch."
                );
              }
            
              const ogUrl = document.querySelector("meta[property='og:url']");
              if (ogUrl) {
                ogUrl.setAttribute("content", "https://msayurved.com/book-appointment");
              }
            
                const ogImage = document.querySelector("meta[property='og:image']");
              if (ogImage) {
                ogImage.setAttribute(
                  "content",
                  "https://msayurved.com/Images/book-appointment.webp"
                );
              }
            
                const twitterTitle = document.querySelector("meta[name='twitter:title']");
              if (twitterTitle) {
                twitterTitle.setAttribute(
                  "content",
                  "Book an Appointment | Dr. Jigar Gor Ayurvedic Clinic"
                );
              }
            
                const twitterDesc = document.querySelector(
                "meta[name='twitter:description']"
              );
              if (twitterDesc) {
                twitterDesc.setAttribute(
                  "content",
                  "Book an appointment with Dr. Jigar Gor for professional Ayurvedic treatment & custom Panchkarma therapies in Bhuj, Kutch."
                );
              }
            
                const twitterImage = document.querySelector("meta[name='twitter:image']");
              if (twitterImage) {
                twitterImage.setAttribute(
                  "content",
                  "https://msayurved.com/Images/book-appointment.webp"
                );
              }
              }, []);

const location = useLocation();

const [formData, setFormData] = useState(() => {
   const params = new URLSearchParams(location.search);

  return{
      consultationMode:
      params.get("mode") === "online"
        ? "Online Consultation"
        : "",
  fullName: "",
  email: "",
  phoneNumber: "",
  city: "",
  appointmentDate: "",
  appointmentTime: "",
  reports: null,
  message: "",
  };
});

useEffect(() => {
  const params = new URLSearchParams(location.search);

  if (params.get("mode") === "online") {
    setFormData((prev) => ({
      ...prev,
      consultationMode: "Online Consultation",
    }));

    const timer = setTimeout(() => {
      document
        .getElementById("appointment-form")
        ?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
    }, 300);

    return () => clearTimeout(timer);
  }
}, [location.search]);

const [loading, setLoading] = useState(false);
const navigate = useNavigate();
const generateToken = useRecaptcha();
const fileInputRef = useRef(null);

const handleChange = (e) => {
  const { name, value, files } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: files ? files[0] : value,
  }));
};

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.consultationMode)
    return toast.error(
      "Please select consultation mode"
    );

  if (!formData.fullName)
    return toast.error(
      "Please enter full name"
    );

  if (!formData.email)
    return toast.error(
      "Please enter email address"
    );

  if (!formData.phoneNumber)
    return toast.error(
      "Please enter phone number"
    );

  if (!formData.city)
    return toast.error(
      "Please enter city"
    );

  if (!formData.appointmentDate)
    return toast.error(
      "Please select appointment date"
    );

  if (!formData.appointmentTime)
    return toast.error(
      "Please select appointment time"
    );

  if (!formData.message)
    return toast.error(
      "Please enter health concerns"
    );

const phoneDigits = formData.phoneNumber.replace(/\D/g, "");

if (phoneDigits.length < 10) {
  return toast.error(
    "Please enter valid phone number"
  );
}

  setLoading(true);
  generateToken(async (token) => {

  try {

  const recaptchaData = new FormData();

      recaptchaData.append(
        "secret",
        "6Lf_Qb4tAAAAAA35Wmjx9ZuK_6_NmESyX4-fAe3p"
      );

      recaptchaData.append(
        "response",
        token
      );

      const verifyRes = await axios.post(
        "https://api.sendmail.adhyaynam.in/recaptcha-verify",
        recaptchaData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data",
          },
        }
      );

      const score =
        verifyRes.data.score ||
        verifyRes.data.data?.score;
        
      if (!score || score <= 0.5) {

        toast.error(
          "Spam detected. Please try again."
        );

        setLoading(false);

        return;
      }

    const template = `
<div style="
background:#F6F5F0;
padding:50px 20px;
font-family:Arial,sans-serif;
">

<table width="100%" cellpadding="0" cellspacing="0">
<tr>
<td align="center">

<table
width="720"
cellpadding="0"
cellspacing="0"
style="
background:#ffffff;
border-radius:24px;
overflow:hidden;
box-shadow:0 20px 50px rgba(0,0,0,0.08);
"
>

<tr>
<td style="
height:8px;
background:#C49A5A;
"></td>
</tr>

<!-- HEADER -->

<tr>
<td style="
background:#1E3A2F;
padding:55px 40px;
text-align:center;
">

<img
src="https://msayurved.com/Images/white-logo.svg"
alt="Dr. Jigar Gor Ayurveda"
style="
display:block;
max-width:180px;
width:100%;
height:auto;
margin:0 auto 25px;
"
/>

<div style="
display:inline-block;
padding:8px 20px;
background:rgba(255,255,255,0.12);
border-radius:50px;
color:#ffffff;
font-size:12px;
letter-spacing:2px;
margin-bottom:18px;
">
NEW APPOINTMENT REQUEST
</div>

<h1 style="
margin:0;
font-size:34px;
font-family:Georgia,serif;
color:#ffffff;
font-weight:700;
">
Appointment Booking
</h1>

<p style="
margin-top:18px;
font-size:15px;
line-height:1.8;
color:#E6ECE8;
">
A new appointment request has been submitted through the website.
</p>

</td>
</tr>

<!-- BODY -->

<tr>
<td style="padding:45px;">

<h2 style="
margin:0 0 20px;
font-size:24px;
font-family:Georgia,serif;
color:#1E3A2F;
">
Patient Information
</h2>

<table
width="100%"
cellpadding="0"
cellspacing="0"
style="
border:1px solid #EAE5DA;
border-radius:16px;
overflow:hidden;
"
>

<tr>
<td style="
padding:18px 24px;
background:#FAF9F5;
border-bottom:1px solid #EAE5DA;
">
<span style="color:#777;">Full Name</span><br>
<strong>${formData.fullName}</strong>
</td>
</tr>

<tr>
<td style="
padding:18px 24px;
border-bottom:1px solid #EAE5DA;
">
<span style="color:#777;">Email Address</span><br>
<strong>${formData.email}</strong>
</td>
</tr>

<tr>
<td style="
padding:18px 24px;
background:#FAF9F5;
border-bottom:1px solid #EAE5DA;
">
<span style="color:#777;">Phone Number</span><br>
<strong>${formData.phoneNumber}</strong>
</td>
</tr>

<tr>
<td style="
padding:18px 24px;
">
<span style="color:#777;">City</span><br>
<strong>${formData.city}</strong>
</td>
</tr>

</table>

<!-- APPOINTMENT DETAILS -->

<h2 style="
margin:35px 0 20px;
font-size:24px;
font-family:Georgia,serif;
color:#1E3A2F;
">
Appointment Details
</h2>

<table
width="100%"
cellpadding="0"
cellspacing="0"
style="
border:1px solid #EAE5DA;
border-radius:16px;
overflow:hidden;
"
>

<tr>
<td style="
padding:18px 24px;
border-bottom:1px solid #EAE5DA;
">
<span style="color:#777;">Consultation Mode</span><br>
<strong style="color:#C49A5A;">
${formData.consultationMode}
</strong>
</td>
</tr>

<tr>
<td style="
padding:18px 24px;
background:#FAF9F5;
border-bottom:1px solid #EAE5DA;
">
<span style="color:#777;">Appointment Date</span><br>
<strong>${formData.appointmentDate}</strong>
</td>
</tr>

<tr>
<td style="
padding:18px 24px;
">
<span style="color:#777;">Appointment Time</span><br>
<strong>${formData.appointmentTime}</strong>
</td>
</tr>

</table>

<!-- REPORT -->

<div style="
margin-top:30px;
background:#FFF8EC;
padding:18px 22px;
border-left:5px solid #C49A5A;
border-radius:10px;
">

<div style="
font-weight:600;
color:#271F12;
margin-bottom:8px;
">
Attached Medical Report
</div>

<div style="
color:#666;
">
${
  formData.reports
    ? formData.reports.name
    : "No report attached"
}
</div>

</div>

<!-- MESSAGE -->

<div style="margin-top:35px;">

<h2 style="
margin-bottom:15px;
font-size:24px;
font-family:Georgia,serif;
color:#1E3A2F;
">
Health Concerns
</h2>

<div style="
background:#F8F7F2;
padding:24px;
border-radius:16px;
border-left:5px solid #C49A5A;
line-height:2;
color:#3B2E1B;
">
${formData.message}
</div>

</div>

</td>
</tr>

<!-- FOOTER -->

<tr>
<td style="
background:#271F12;
padding:35px;
text-align:center;
">

<h3 style="
margin:0;
font-family:Georgia,serif;
font-size:22px;
color:#ffffff;
">
Dr. Jigar Gor Ayurveda Clinic
</h3>

<p style="
margin-top:12px;
font-size:13px;
line-height:1.8;
color:#D8C4A1;
">
Authentic Ayurveda • Panchkarma • Garbh Sanskar • Holistic Healing
</p>

<p style="
margin-top:12px;
font-size:12px;
color:#BFA988;
">
Bhuj, Gujarat
</p>

</td>
</tr>

</table>

</td>
</tr>
</table>

</div>
`;

    const data = new FormData();

    data.append(
      "title",
      "Appointment Booking Form"
    );

    data.append(
      "to_email",
      "dr.jigargor@yahoo.com"
    );

    data.append(
      "cc",
      "arkayappsseo@gmail.com,sales@arkayapps.com"
    );

    data.append(
      "subject",
      "New Appointment Booking"
    );

    data.append(
      "template",
      template
    );

    if (formData.reports) {
      data.append(
        "file",
        formData.reports
      );
    }

    await axios.post(
      "https://api.sendmail.adhyaynam.in/send-mail/two",
      data,
      {
        headers: {
          "Content-Type":
            "multipart/form-data",
        },
      }
    );

    const whatsappData = {
  fullName: formData.fullName,
  email: formData.email,
  phoneNumber: formData.phoneNumber,
  city: formData.city,
  consultationMode: formData.consultationMode,
  appointmentDate: formData.appointmentDate,
  appointmentTime: formData.appointmentTime,
};

 await axios.post(
  "/.netlify/functions/book-appointment",
  whatsappData,
  {
    headers: {
      "Content-Type": "application/json",
    },
  }
);

const patientWhatsappData = {
  fullName: formData.fullName,
  phoneNumber: formData.phoneNumber,
  appointmentDate: formData.appointmentDate,
  appointmentTime: formData.appointmentTime,
  consultationMode: formData.consultationMode,
};

await axios.post(
  "/.netlify/functions/patient-appointment",
  patientWhatsappData,
  {
    headers: {
      "Content-Type": "application/json",
    },
  }
);

sendMetaEvent("AppointmentSubmitted");

    toast.success(
      "Appointment booked successfully."
    );

    setFormData({
      consultationMode: "",
      fullName: "",
      email: "",
      phoneNumber: "",
      city: "",
      appointmentDate: "",
      appointmentTime: "",
      reports: null,
      message: "",
    });

    if (fileInputRef.current) {
  fileInputRef.current.value = "";
}
sessionStorage.setItem("trackThankYouLead", "true");
navigate("/thank-you");

  } catch (error) {

    toast.error(
      "Something went wrong. Please try again."
    );

  } finally {

    setLoading(false);

  }
  });

};

const breadcrumbItems = [
    {
      name: "Home",
      url: "https://msayurved.com/"
    },
    {
      name: "Book an Appointment",
      url: "https://msayurved.com/book-appointment"
    },
  ];
    return(
        <>

      <BookAppointmentSchema />
  <MedicalClinicSchema />
  <BreadcrumbSchema items={breadcrumbItems} />

        <ToastContainer
          position="top-right"
          autoClose={3000}
        />

         {/**BREADCRUMB SECTION */}
        <Breadcrumb
        title="Book an Appointment "
        bgImage={bgImg}
        />

       <motion.section
       id="appointment-form"
  className="contact-section appointment-section container"
  initial={{
    opacity: 0,
  }}
  whileInView={{
    opacity: 1,
  }}
  viewport={{
    once: true,
    amount: 0.1,
  }}
  transition={{
    duration: 0.9,
    ease: "easeOut",
  }}
>

  {/* LEFT FORM */}
<motion.div
  className="contact-form-wrapper"
  initial={{
    opacity: 0,
    x: -40,
  }}
  whileInView={{
    opacity: 1,
    x: 0,
  }}
  viewport={{
    once: true,
    amount: 0.2,
  }}
  transition={{
    duration: 1,
    ease: "easeOut",
  }}
>

  <motion.h2
    className="section-heading"
    initial={{
      opacity: 0,
      y: 20,
    }}
    whileInView={{
      opacity: 1,
      y: 0,
    }}
    viewport={{
      once: true,
    }}
    transition={{
      duration: 0.8,
      delay: 0.1,
    }}
  >
    Book an Appointment
  </motion.h2>

  <motion.p
    className="section-text"
    initial={{
      opacity: 0,
      y: 15,
    }}
    whileInView={{
      opacity: 1,
      y: 0,
    }}
    viewport={{
      once: true,
    }}
    transition={{
      duration: 0.8,
      delay: 0.2,
    }}
  >
    Fill out the form bellow and we’ll get back to you as soon as possible
  </motion.p>

  <form
  className="contact-form"
  onSubmit={handleSubmit}
>

    {/* CONSULTATION TYPE */}

    <motion.div
      className="consultation-type full-width"
      initial={{
        opacity: 0,
        y: 15,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      viewport={{
        once: true,
      }}
      transition={{
        duration: 0.8,
        delay: 0.3,
      }}
    >

      <label>Select Consultation Mode *</label>

      <div className="consultation-options">

        <motion.label
          className="consultation-option"
          whileHover={{
            scale: 1.02,
          }}
          transition={{
            duration: 0.3,
          }}
        >
          <input
  type="radio"
  name="consultationMode"
  value="Online Consultation"
  checked={
    formData.consultationMode ===
    "Online Consultation"
  }
  onChange={handleChange}
/>
          <span className="custom-radio"></span>
          Online Consultation
        </motion.label>

        <motion.label
          className="consultation-option"
          whileHover={{
            scale: 1.02,
          }}
          transition={{
            duration: 0.3,
          }}
        >
        <input
  type="radio"
  name="consultationMode"
  value="Offline Consultation"
  checked={
    formData.consultationMode ===
    "Offline Consultation"
  }
  onChange={handleChange}
/>
          <span className="custom-radio"></span>
          Offline Consultation
        </motion.label>

      </div>

    </motion.div>

    {/* ROW 1 */}

    <motion.div
      className="form-group"
      initial={{
        opacity: 0,
        y: 15,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      viewport={{
        once: true,
      }}
      transition={{
        duration: 0.7,
        delay: 0.35,
      }}
    >
      <label>Full Name *</label>

      <input
  type="text"
  name="fullName"
  value={formData.fullName}
  onChange={handleChange}
  placeholder="Enter your Full Name"
/>
    </motion.div>

    <motion.div
      className="form-group"
      initial={{
        opacity: 0,
        y: 15,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      viewport={{
        once: true,
      }}
      transition={{
        duration: 0.7,
        delay: 0.4,
      }}
    >
      <label>Email Address *</label>

     <input
  type="email"
  name="email"
  value={formData.email}
  onChange={handleChange}
  placeholder="Enter Email Address"
/>
    </motion.div>

    {/* ROW 2 */}

<motion.div
  className="form-group"
  initial={{
    opacity: 0,
    y: 15,
  }}
  whileInView={{
    opacity: 1,
    y: 0,
  }}
  viewport={{
    once: true,
  }}
  transition={{
    duration: 0.7,
    delay: 0.45,
  }}
>
  <label>Phone Number *</label>

  <PhoneInput
    country="in"
    value={formData.phoneNumber}
    onChange={(phone) =>
      setFormData((prev) => ({
        ...prev,
        phoneNumber: phone,
      }))
    }
    enableSearch
    searchPlaceholder="Search country"
    countryCodeEditable={false}
    placeholder="Enter your Contact Number"
    inputProps={{
      name: "phoneNumber",
      required: true,
    }}
  />
</motion.div>

    <motion.div
      className="form-group"
      initial={{
        opacity: 0,
        y: 15,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      viewport={{
        once: true,
      }}
      transition={{
        duration: 0.7,
        delay: 0.5,
      }}
    >
      <label>City *</label>

      <input
  type="text"
  name="city"
  value={formData.city}
  onChange={handleChange}
  placeholder="Enter your City Name"
/>
    </motion.div>

    {/* ROW 3 */}

    <motion.div
      className="form-group"
      initial={{
        opacity: 0,
        y: 15,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      viewport={{
        once: true,
      }}
      transition={{
        duration: 0.7,
        delay: 0.55,
      }}
    >
      <label>Select Date *</label>

     <input
  type="date"
  name="appointmentDate"
  value={formData.appointmentDate}
  onChange={handleChange}
/>
    </motion.div>

    <motion.div
      className="form-group"
      initial={{
        opacity: 0,
        y: 15,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      viewport={{
        once: true,
      }}
      transition={{
        duration: 0.7,
        delay: 0.6,
      }}
    >
      <label>Select Time *</label>

      <input
  type="time"
  name="appointmentTime"
  value={formData.appointmentTime}
  onChange={handleChange}
/>
    </motion.div>

    {/* REPORTS */}

    <motion.div
      className="form-group full-width"
      initial={{
        opacity: 0,
        y: 15,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      viewport={{
        once: true,
      }}
      transition={{
        duration: 0.7,
        delay: 0.65,
      }}
    >

      <label>Add Reports / Old Prescription</label>

<input
  type="file"
  name="reports"
  onChange={handleChange}
  ref={fileInputRef}
/>
    </motion.div>

    {/* MESSAGE */}

    <motion.div
      className="form-group full-width"
      initial={{
        opacity: 0,
        y: 15,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      viewport={{
        once: true,
      }}
      transition={{
        duration: 0.7,
        delay: 0.7,
      }}
    >

      <label>Message *</label>

      <textarea
  rows="5"
  name="message"
  value={formData.message}
  onChange={handleChange}
  placeholder="Write down about your health concerns in detail"
/>
    </motion.div>

    <div className="submit-wrap">

     <motion.button
  type="submit"
  className="nav-btn"
  disabled={loading}
  whileHover={{
    scale: 1.03,
    y: -2,
  }}
  whileTap={{
    scale: 0.98,
  }}
  transition={{
    duration: 0.3,
  }}
>
  {loading
    ? "Booking..."
    : "Book Appointment"}
</motion.button>
    </div>

  </form>

</motion.div>

  {/* RIGHT SIDEBAR */}
<motion.div
  className="contact-info"
  initial={{
    opacity: 0,
    x: 40,
  }}
  whileInView={{
    opacity: 1,
    x: 0,
  }}
  viewport={{
    once: true,
    amount: 0.2,
  }}
  transition={{
    duration: 1,
    ease: "easeOut",
  }}
>

  <motion.h2
    className="section-heading"
    initial={{
      opacity: 0,
      y: 20,
    }}
    whileInView={{
      opacity: 1,
      y: 0,
    }}
    viewport={{
      once: true,
    }}
    transition={{
      duration: 0.8,
      delay: 0.1,
    }}
  >
    Contact Information
  </motion.h2>

  <motion.p
    className="section-text"
    initial={{
      opacity: 0,
      y: 15,
    }}
    whileInView={{
      opacity: 1,
      y: 0,
    }}
    viewport={{
      once: true,
    }}
    transition={{
      duration: 0.8,
      delay: 0.2,
    }}
  >
    Whether you need to schedule a consultation, have a question about our treatments, or need ongoing patient support, please reach out. Our medical team will get back to you as soon as possible.
  </motion.p>

  <motion.div
    className="contact-divider"
    initial={{
      scaleX: 0,
      opacity: 0,
    }}
    whileInView={{
      scaleX: 1,
      opacity: 1,
    }}
    viewport={{
      once: true,
    }}
    transition={{
      duration: 0.8,
      delay: 0.3,
    }}
    style={{
      transformOrigin: "left",
    }}
  />

  <div className="contact-info-list">

    <motion.div
      className="contact-info-item"
      initial={{
        opacity: 0,
        y: 20,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      viewport={{
        once: true,
      }}
      transition={{
        duration: 0.7,
        delay: 0.35,
      }}
    >

      <motion.div
        className="contact-icon"
        whileHover={{
          scale: 1.08,
        }}
        transition={{
          duration: 0.3,
        }}
      >
        <FaPhoneAlt />
      </motion.div>

      <div>
        <h3 className="card-heading">Phone</h3>

        <a
          href="tel:+919099094847"
           onClick={() => sendMetaEvent("PhoneClick")}
          className="section-text"
        >
          +91 90990 94847
        </a>
      </div>

    </motion.div>

    <motion.div
      className="contact-info-item"
      initial={{
        opacity: 0,
        y: 20,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      viewport={{
        once: true,
      }}
      transition={{
        duration: 0.7,
        delay: 0.5,
      }}
    >

      <motion.div
        className="contact-icon"
        whileHover={{
          scale: 1.08,
        }}
        transition={{
          duration: 0.3,
        }}
      >
        <FaEnvelope />
      </motion.div>

      <div>
        <h3 className="card-heading">Email</h3>

        <a
          href="mailto:dr.jigargor@yahoo.com"
          className="section-text"
        >
          dr.jigargor@yahoo.com
        </a>
      </div>

    </motion.div>

    <motion.div
      className="contact-info-item"
      initial={{
        opacity: 0,
        y: 20,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      viewport={{
        once: true,
      }}
      transition={{
        duration: 0.7,
        delay: 0.65,
      }}
    >

      <motion.div
        className="contact-icon"
        whileHover={{
          scale: 1.08,
        }}
        transition={{
          duration: 0.3,
        }}
      >
        <FaMapMarkerAlt />
      </motion.div>

      <div>
        <h3 className="card-heading">Address</h3>

        <p className="section-text">
          Narayan Complex, Near Lohana Samaj Wadi,
          Madhapar - Tal. Bhuj-Kutch,
          Gujarat - 370020
        </p>
      </div>

    </motion.div>

  </div>

  <motion.div
    className="appointment-map"
    initial={{
      opacity: 0,
      y: 20,
    }}
    whileInView={{
      opacity: 1,
      y: 0,
    }}
    viewport={{
      once: true,
    }}
    transition={{
      duration: 1,
      delay: 0.8,
    }}
  >

    <iframe
      title="Clinic Location"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3666.1197928738698!2d69.7049829757188!3d23.23872747902289!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3950e1985591400b%3A0xa8884bd7e6e66dc7!2sDr.Jigar%20Gor%20's%20Ayurveda%20Clinic%20Bhuj!5e0!3m2!1sen!2sin!4v1780477756976!5m2!1sen!2sin"
      loading="lazy"
      allowFullScreen
    />

  </motion.div>

</motion.div>

</motion.section>
        </>
    )
}
export default BookAppointment